import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { _parseDateRange } from "../helper-payroll/HelperFunction";
import { findObjectUseCase, countObjectUseCase } from "../../../../usecases/object";

class ModalContentFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async _fetchEmployeesChunked(query, batchSize = 500, concurrency = 3) {
    const collection = "employees";
    const { count = 0 } = await countObjectUseCase().execute(collection, { where: query.where });

    if (count === 0) {
      return [];
    }

    const skips = [];
    for (let skip = 0; skip < count; skip += batchSize) {
      skips.push(skip);
    }

    const rowsBySkip = {};
    for (let i = 0; i < skips.length; i += concurrency) {
      const currentSkips = skips.slice(i, i + concurrency);
      const batchResults = await Promise.all(
        currentSkips.map(async (currentSkip) => {
          const isolatedFindUseCase = findObjectUseCase();
          const rows = await isolatedFindUseCase.execute(collection, { ...query, limit: batchSize, skip: currentSkip });
          return { currentSkip, rows: rows || [] };
        })
      );

      for (const { currentSkip, rows } of batchResults) {
        rowsBySkip[currentSkip] = rows;
      }
    }

    const objects = skips.flatMap((currentSkip) => rowsBySkip[currentSkip] || []);

    return objects;
  }

  async componentDidMount() {
    super.componentDidMount();
    this.view.setState({ isLoading: true });

    const { query } =  this.view.props.panelState;
    const { limit, skip, ...restQuery } = query;

    try {
      const objects = await this._fetchEmployeesChunked({...restQuery });

      console.log("objects++", objects);
    } catch (error) {
      console.log("error", error);
    } finally {
      this.view.setState({ isLoading: false });
    }

    console.log("query", query);

  }

  _onChangeDate(dateString) {
    if (!this.object) {
      this.object = {};
      this.change = {};
    }

    if (!dateString || (Array.isArray(dateString) && (!dateString[0] || !dateString[1]))) {
      const { periodCovered, ...restObject } = this.object;
      this.object = restObject;
      if (this.change.periodCovered !== null && this.change.periodCovered !== undefined) {
        delete this.change.periodCovered;
      }
      this.view.setObject({ ...this.object });
      return;
    }

    const periodCovered = _parseDateRange(dateString);
    
    const { year, ...restObject } = this.object;
    this.object = {
      ...restObject,
      periodCovered,
    };

    this.change.periodCovered = periodCovered;
    if (this.change.year !== null && this.change.year !== undefined) {
      delete this.change.year;
    }
    this.view.setObject({ ...this.object });
  }

}

export default ModalContentFormPresenter;
